import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-partnerregister-page',
  templateUrl: './partnerregister-page.component.html',
  styleUrls: ['./partnerregister-page.component.css'],
})
export class PartnerregisterPageComponent implements OnInit {
  partnerregisterForm: FormGroup;
  private registerApi = environment.url + environment.register;
  /**
   * Constructs the component.
   * @param router The Angular router service
   * @param fb The Angular form builder service
   * @param makeapi The API service
   * @param getdata The service that exposes application state
   * @param notify The service that provides toast notifications
   */
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService
  ) {
    /**
     * Creates the partner registration form with default values and validators
     */
    this.partnerregisterForm = this.fb.group({
      /**
       * The partner's name
       */
      name: ['', [Validators.required]],
      /**
       * The partner's phone number
       */
      phone: [
        '',
        [
          /**
           * The phone number should be in the format +91-XXXXXXXXXX or 0XXXXXXXXXX
           */
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],
      /**
       * The partner's email
       */
      email: ['', [Validators.required, Validators.email]],
      /**
       * The partner's role ID
       */
      roleid: ['5'],
    });
  }
  get add() {
    return this.partnerregisterForm.controls;
  }
  ngOnInit(): void {
    this.getdata.isVisibleSource.next(true);
  }

  /**
   * Submits the partner registration form and makes an API call to register the
   * user.
   * If the form is invalid, shows an error notification and returns.
   * If the API call is successful, shows a success modal and sets the
   * If the API call fails, shows an error notification.
   */
  registerpartnerAdmin() {
    let getform = this.partnerregisterForm.value;
    if (this.partnerregisterForm.invalid) {
      // If the form is invalid, show an error notification and return
      this.partnerregisterForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
      return;
    } else {
      // Show the loader
      this.getdata.amizhthLoader('show');
      // Make the API call
      this.makeapi
        .method(this.registerApi, getform, 'login')
        .subscribe((data) => {
          // Hide the loader
          this.getdata.amizhthLoader('hide');
          if (data.responseStatus == 'Success') {
            // If the API call is successful, show a success modal and set the
            document.getElementById('RegisterModal').style.display = 'block';
          } else {
            // If the API call fails, show an error notification
            this.notify.notifyError(data.responseMessage);
          }
        });
    }
  }
  /**
   * Resets the partner registration form and navigates to the home page.
   * This is called when the user clicks the cancel button.
   */
  cancelReg() {
    // Reset the form
    this.partnerregisterForm.reset();
    // Navigate to the home page
    this.router.navigateByUrl('/home');
  }
  /**
   * Closes the modal by navigating to the login page
   */
  closeModal(): void {
    // Navigate to the login page
    this.router.navigateByUrl('/login');
  }
}
